module.exports = __webpack_public_path__ + "img/vision-image.605f7014.png";